import React, { useEffect, useState } from 'react'
import Loading from '../general/Loading';
import { useNavigate } from 'react-router-dom';

const Overview = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [prescription, setPrescription] = useState([]);
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);


useEffect(() => {
  fetchOrders();
  fetchPrescription();
fetchProducts();
}, [])

      const fetchProducts = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-product');
        if (response.ok) {
          const data = await response.json();
const sortedProducts = data.sort((a, b) => b.id - a.id);          setProducts(sortedProducts);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    const fetchOrders = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-orders`);
        setLoading(false);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
          console.log(sortedProducts);
          setOrders(sortedProducts);
        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching products:', error);
      }
    };


            const fetchPrescription = async () => {
          setLoading(true);
          try {
            const response = await fetch(`https://api.kcmstore.in/store/get-prescription`);
            setLoading(false);
            if (response.ok) {
              const data = await response.json();
              const sortedProducts = data.sort((a, b) => b.id - a.id);
const pendingOrders = sortedProducts.filter(
  item => item.status == "pending"
);
              setPrescription(pendingOrders);
            } else {
              console.error('Failed to fetch prescription');
            }
          } catch (error) {
            setLoading(false);
            console.error('Error fetching prescription:', error);
          }
        };
    

const today = new Date().toISOString().split("T")[0];

const todaysSale = orders
  .filter(order => order.order_date.startsWith(today))
  .reduce((sum, order) => sum + Number(order.total_amount), 0);

  
const todaysOrders = orders.filter(order =>
  order.order_date.startsWith(today)
);

const topProductsMap = {};

orders.forEach(order => {
  let items = order.order_items;

  if (typeof items === "string") {
    try {
      items = JSON.parse(items);
    } catch {
      items = [];
    }
  }

  items?.forEach(item => {
    const name = item.product_name;

    if (!topProductsMap[name]) {
      topProductsMap[name] = {
        name,
        quantity: 0,
        image: item.image
      };
    }

    topProductsMap[name].quantity += Number(item.quantity);
  });
});

const topProducts = Object.values(topProductsMap)
  .sort((a, b) => b.quantity - a.quantity)
  .slice(0, 40);


  const lowStockProducts = products
  .filter(item => Number(item.stock) <= 10)
  .sort((a, b) => a.stock - b.stock)
  .slice(0, 10);

  // Online Orders
const onlineOrders = todaysOrders.filter(
  o => o.payment_mode?.toLowerCase() == "online"
);

const onlineAmount = onlineOrders.reduce(
  (sum, o) => sum + Number(o.total_amount),
  0
);

// COD Orders
const codOrders = todaysOrders.filter(
  o => o.payment_mode?.toLowerCase() == "cash on delivery"
);

const codAmount = codOrders.reduce(
  (sum, o) => sum + Number(o.total_amount),
  0
);

// Out for Delivery
const outForDelivery = orders.filter(
  o => o.order_status?.toLowerCase() == "out for delivery"
);

  return (
    <>
                <section className='py-4 bg-light'>
                <div className='px-3'>

                    <div className='d-flex'>
                        <p className='sec-heading'>Overview</p>
                        <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Track</span>
                    </div>


<div className="row">
  {/* Today's Sale */}
  <div className="col-md-4 mb-3 cursor-pointer" onClick={() => navigate('/manage-orders')}>
    <div className="bg-white p-3 rounded shadow-sm text-start">
      <h6 className="text-muted">Today's Sale</h6>
      <div className='d-flex justify-content-between'>
        <h4 className="fw-bold text-success">₹ {todaysSale.toFixed(2)}</h4>
<i className="fa-solid fa-receipt text-success fs-2"></i></div>
    </div>
  </div>

  {/* Total Sale */}
  <div className="col-md-4 mb-3 cursor-pointer" onClick={() => navigate('/manage-orders')}>
    <div className="bg-white p-3 rounded shadow-sm text-start">
      <h6 className="text-muted">Today's Orders</h6>
      <div className='d-flex justify-content-between'>
      <h4 className="fw-bold text-primary">{todaysOrders.length}</h4>
<i class="fa-solid fa-bag-shopping text-primary fs-2"></i>      </div>
    </div>
  </div>

    <div className="col-md-4 mb-3 cursor-pointer" onClick={() => navigate('/manage-prescription')}>
    <div className="bg-white p-3 rounded shadow-sm text-start">
      <h6 className="text-muted">Pending Prescriptions</h6>
      <div className='d-flex justify-content-between'>
      <h4 className="fw-bold text-warning">{prescription.length}</h4>
<i class="fa-solid fa-clock text-warning fs-2"></i>      </div>
    </div>
  </div>

{/* Online Orders */}
<div className="col-md-4 mb-3 cursor-pointer" onClick={() => navigate('/manage-orders')}>
  <div className="bg-white p-3 rounded shadow-sm text-start">
    <h6 className="text-muted">Online Orders</h6>
    <div className="d-flex justify-content-between">
      <div>
        <h5 className="fw-bold text-info">{onlineOrders.length}        
          <span className='para-text fs-6'>&nbsp;&nbsp;&nbsp;&nbsp;₹ {onlineAmount.toFixed(2)}</span>
</h5>
      </div>
      <i className="fa-solid fa-credit-card text-info fs-2"></i>
    </div>
  </div>
</div>

{/* COD Orders */}
<div className="col-md-4 mb-3 cursor-pointer" onClick={() => navigate('/manage-orders')}>
  <div className="bg-white p-3 rounded shadow-sm text-start">
    <h6 className="text-muted">COD Orders</h6>
    <div className="d-flex justify-content-between">
      <div>
        <h5 className="fw-bold text-danger">{codOrders.length}
                    <span className='para-text fs-6'>&nbsp;&nbsp;&nbsp;&nbsp;₹ {codAmount.toFixed(2)}</span>

        </h5>
      </div>
      <i className="fa-solid fa-money-bill-wave text-danger fs-2"></i>
    </div>
  </div>
</div>

{/* Out for Delivery */}
<div className="col-md-4 mb-3 cursor-pointer" onClick={() => navigate('/delivery-history')}>
  <div className="bg-white p-3 rounded shadow-sm text-start">
    <h6 className="text-muted">Out for Delivery</h6>
    <div className="d-flex justify-content-between">
      <h4 className="fw-bold text-darkblue">{outForDelivery.length}</h4>
      <i className="fa-solid fa-truck text-darkblue fs-2"></i>
    </div>
  </div>
</div>

</div>

{/* row ends */}

<div className='row'>

  <div className='col-lg-4 col-12 my-2'>
    <p className='sec-text'>Low Stock Medicines</p>

    <div className="bg-white p-3 rounded shadow-sm">

    {lowStockProducts.length > 0 ? (
      lowStockProducts.map((product, index) => (
        <div
          key={index}
          className="d-flex align-items-center justify-content-between mb-2 border-bottom pb-2 cursor-pointer"
          onClick={() => navigate('/manage-products')}
        >

          <div className="d-flex align-items-center">
            <img
              src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`}
              alt={product.name}
              style={{ height: "40px", width: "40px", objectFit: "contain" }}
              className="me-2"
            />

            <p
              className="mb-0 small fw-semibold"
              style={{
                maxWidth: "120px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {product.name}
            </p>
          </div>

          <span className="text-danger fw-bold">
            {product.stock}
          </span>

        </div>
      ))
    ) : (
      <p className="text-muted small">No low stock items</p>
    )}

  </div>
</div>

<div className='col-lg-8 col-12 my-2'>
<p className='sec-text'>In Demand Range</p>

<div className="row">
  {topProducts.length > 0 ? (
    topProducts.map((product, index) => (
      <div className="col-md-3 col-6 mb-3" key={index} >
        <div className="bg-white p-2 rounded shadow-sm text-center cursor-pointer" onClick={() => navigate('/dashboard')}>

          <img
            src={`https://api.kcmstore.in/sUploads/${product.image}`}
            alt={product.name}
            style={{ height: "80px", objectFit: "contain" }}
            className="mb-2"
          />

          <p className="mb-1 fw-semibold small" style={{
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }}>
            {product.name}
          </p>

          <p className="text-muted small fw-semibold">
            Sold: {product.quantity}
          </p>

        </div>
      </div>
    ))
  ) : (
    <p className="text-muted">No data available</p>
  )}
</div>
{/* inner row ends */}
</div>


</div>



</div>
</section>

{loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default Overview